module.exports = __webpack_public_path__ + "img/djyl.9c37d950.png";